<template>
  <div
    class="input-select d-block"
    v-on-clickaway="closeSelect" >
    <label
      v-if="label"
      @click="closeSelect"
      style="position: relative;">
      {{ label }}
      <!-- Info icon with tooltip -->
      <span
        v-if="hint"
        class="hint-tooltip-wrapper"
        style="position: relative; display: inline-flex; margin-left: 10px; width: 3px; vertical-align: middle;">
        <Icon
          class="icon hint-icon"
          name="info"
          size="14"
          style="cursor: help; color: #999; position: relative; top: 2px;"
          @mouseenter.native="showTooltip = true"
          @mouseleave.native="showTooltip = false"/>

        <span
          v-show="showTooltip"
          class="hint-tooltip"
          style="border: 1px solid black; position: absolute; bottom: calc(100% + 10px); left: 50%; transform: translateX(-50%);
                 background: #333; color: #fff; padding: 8px 12px; border-radius: 4px;
                 white-space: nowrap; font-size: 12px; z-index: 1000;
                 box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
          {{ $t(hint) }}
          <!-- Arrow -->
          <span style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%);
                       width: 0; height: 0; border-left: 6px solid transparent;
                       border-right: 6px solid transparent; border-top: 6px solid #333;"></span>
        </span>
      </span>
      <span v-if="rules.required" class="warning-color">*</span>
    </label>
    <div
      :class="{required: shouldShowError, disabled: disabled}"
      @click="openListOnClick"
      class="input-like"
      :tabindex="disabled ? -1 : 0"
      @focus="openListOnFocus">
      <span v-if="cmpTextValue.text === ''">{{ $t('select') }}</span>
      <span v-else
        :class="['',
          (darkText ? 'dark-text':''),
          ((countryFlag && cmpTextValue != '') ? 'cut-text-calc' : 'cut-text'),
        ]">
        {{ shouldTranslate ? $t(cmpTextValue.text) : cmpTextValue.text }}
      </span>
      <CountryFlag
        class="select-flag"
        v-if="countryFlag && cmpTextValue != ''"
        :country="cmpTextValue.countryFlag"
        size='normal' />
      <Icon
        class="icon"
        name="arrowDown"
        size="28" />
    </div>
    <div
      v-show="isListOpened"
      :class="listPosition"
      class="options-list"
      ref="selectReference">
      <input
        ref="searchField"
        v-show="options.length > showSearch"
        class="search"
        v-model="search"
        @keydown="searchIt"
        :placeholder="$t('Search...')" />
      <hr v-if="multiSelect" v-show="options.length > showAllButtons" />
      <div class="row-no-gutters multiselect-global-controls c-float" v-if="multiSelect" v-show="options.length > showAllButtons">
        <div class="col-xs-6"><div class="button light d-inline-block" @click="selectAll"><span class="button-text">{{ $t('select_all')}}</span></div></div>
        <div class="col-xs-6"><div class="button light d-inline-block" @click="selectNone"><span class="button-text">{{ $t('unselect_all')}}</span></div></div>
      </div>
      <ul>
        <li
          @keydown.prevent="nextItem"
          tabIndex="-1"
          v-for="(item, index) in filteredList"
          :key="`option-${index}`"
          :class="{active: indexItem === index}"
          :ref="`${randomSelectId}-${index}-opt`"
          @click.prevent="changeValue(index, item)">
          <Checkbox
            v-if="multiSelect"
            :value="preselected.indexOf(String(item.value)) > -1"
            class="m-r-10" />
          {{ shouldTranslate ? $t(item.text) : item.text }}
          <CountryFlag
            v-if="countryFlag && item.country != '' && item.country != undefined"
            :country="item.country"
            class="" size='normal' style="position: absolute;right: 10px;"/>
          <input :value="item.value" type="checkbox" style="display: none;"/>
        </li>
      </ul>
    </div>
    <span v-if="shouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
  </div>
</template>

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import CountryFlag from 'vue-country-flag';
import Checkbox from '@/components/elements/inputs/checkbox';
import rules from "@/mixins/rules";

export default {
  name: 'InputSelect',
  mixins: [rules],
  directives: {
    onClickaway: onClickaway,
  },
  components: {
    CountryFlag, Checkbox,
  },
  props: {
    hint: {
      type: String,
      default: ''
    },
    shouldTranslate: {
      type: Boolean,
      default: true,
    },
    log: {
      type: Boolean,
      default: false,
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    parentContainerHeight: {
      type: [String, Number],
      default: '0',
    },
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
    darkText: {
      type: Boolean,
      default: false,
    },
    countryFlag: {
      type: Boolean,
      default: false,
    },
    renderCustomText: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String, Boolean, Array],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Number,
      default: 7,
    },
    showAllButtons: {
      type: Number,
      default: 3,
    },
    preselected: {
      type: Array,
      deafult: () => {
        return [];
      },
    },
  },
  data() {
    return {
      indexItem: 0,
      isListOpened: false,
      openedOnClick: false,
      search: '',
      listPosition: 'bottom',
      multiSelectArray: [],
      showTooltip: false,
    };
  },
  computed: {
    filteredList() {
      if(this.options.length < 1) return [];
      let selectedList = this.options.filter(option => {
        if(option.hasOwnProperty('selected')){
          if(!option.selected) return option;
        } else {
          return option;
        }
      });
      return selectedList.filter(option => {
        return option.text.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    cmpTextValue() {
      if(this.multiSelect){
        const arrayResult = [];
        if(this.preselected.length > 0){
          this.options.forEach((item) => {
            if(this.preselected.indexOf(String(item.value)) > -1){
              arrayResult.push(this.shouldTranslate ? this.$t(item.text) : item.text)
            }
          });
        }

        return {
          text: this.preselected.length > 0 ? arrayResult.join(', ') :  this.$t('select'),
          countryFlag: this.countryFlag ? this.options.filter(opt => opt.value == this.value)[0].country : '',
        }
      }
      if(this.value === undefined) return ''; //Ovo prekontrolisi || this.value === null
      if( (this.value !== '') && (this.options.length > 0) ) {
        this.options.filter((opt, index) => {
          if(opt.value == this.value) this.indexItem = index;
        });
        if (!this.options.filter(opt => opt.value == this.value)[0]) {
          return '';
        }
        let text = this.options.filter(opt => opt.value == this.value)[0].text || '';
        if(text === ''){
          return '';
        } else {
          return {
            text: this.options.filter(opt => opt.value == this.value)[0].text,
            countryFlag: this.countryFlag ? this.options.filter(opt => opt.value == this.value)[0].country : '',
          };
        }
      }
      return '';
    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
  },
  methods: {
    selectAll() {
      this.preselected = []
      this.filteredList.forEach(item => {
        this.onChange(true, item)
      })
    },
    selectNone() {
      this.$emit('change', []);
      this.$emit('input', []);
    },
    searchIt(event) {
      if(event.keyCode == 9) this.closeSelect();
      if (event.keyCode == 38 || event.keyCode == 40) {
      	this.nextItem(event);
      } else {
        this.indexItem = 0;
        // this.search = event.target.value;
      }
    },
    nextItem (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItem > 0) {
      	this.indexItem--;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.options.length - 1) {
      	this.indexItem++;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
      }
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    changeValue(index, option) {
      if( !this.multiSelect ){
        this.indexItem = index;
        this.isListOpened = false;
        this.openedOnClick = false;
        this.$emit('changeCustom', option);
        this.$emit('change', option.value);
        this.$emit('input', option.value);
        this.search = '';
      } else {
        this.onChange(null, option);
      }
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
    },
    calculatePosition() {
      if( this.$parent.$refs.popupContent !== undefined){
        const dropdownPosition = this.$refs.selectReference.getBoundingClientRect();
        const parentBox = this.$parent.$refs.popupContent.getBoundingClientRect();

        if(dropdownPosition.top + dropdownPosition.height > parentBox.bottom){
          this.listPosition = 'top';
        } else {
          this.listPosition = 'bottom';
        }

      } else {
        const dropdownPosition = this.$refs.selectReference.getBoundingClientRect();
        if(dropdownPosition.top + dropdownPosition.height > window.innerHeight){
          this.listPosition = 'top';
        } else {
          this.listPosition = 'bottom';
        }
      }
    },
    openListOnClick() {
      if (this.disabled) {
        return;
      }
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        if( this.filteredList.length > this.showSearch){
          this.$refs.searchField.focus();
        }
      });
    },
    openListOnFocus() {
      if (this.disabled) {
        return;
      }
      this.isListOpened = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        if( this.filteredList.length > this.showSearch){
          this.$refs.searchField.focus();
        }
      });
    },
    onChange(val, item) {
      let newArray = [...this.preselected]
      if (val !== null) {
        newArray = this.preselected
      }

      if(newArray.indexOf(String(item.value)) > -1){
        newArray.splice(newArray.indexOf(String(item.value)), 1);
      } else {
        newArray.push(String(item.value));
      }

      this.$emit('change', newArray);
      this.$emit('input', newArray);
    },
  },
}
</script>
